import React, {useState, useEffect} from 'react';
import {Link} from "gatsby"
import logo from "../../../../images/logo-orange.png"
import "./navbar.css"

const Navbar = ({scroll}) => {

    const [isNavCollapsed, setIsNavCollapsed] = useState(true);

    const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

    return (
        <nav
            className={`${scroll ? '' : 'fixed-top container container-fluid'} bg-white navbar-expand-lg d-flex flex-wrap justify-content-between align-items-center py-2`}
        >
            <Link
                href="/"
            >
                <div className="d-flex justify-content-between align-items-center">
                    <img
                        src={logo}
                        alt=""
                        className={`${scroll ? 'img-size' : 'img-size-new'}`}
                    />
                </div>
            </Link>

            <button
                className="custom-toggler navbar-toggler"
                onClick={handleNavCollapse}
            >
                <span className="bi bi-list btn-outline-orange"/>
            </button>

            <div
                className={`${isNavCollapsed ? 'collapse d-none' : 'collapse d-none'} navbar-collapse d-flex align-items-center justify-content-end`}
            >
                <ul className="nav nav-pills d-flex flex-sm-column flex-lg-row align-items-center">
                    <li className={`nav-item`}>
                        <Link to="/#products" className={`nav-link link-orange`}>
                            Products
                        </Link>
                    </li>
                    <li className={`nav-item`}>
                        <Link to="/#testimonials" className={`nav-link link-orange`}>
                            Testimonials
                        </Link>
                    </li>
                    <li className={`nav-item`}>
                        <Link to="/#about" className={`nav-link link-orange`}>
                            About Us
                        </Link>
                    </li>
                    <li className={`nav-item`}>
                        <Link to="/#contact" className={`btn btn-orange btn-lg rounded-pill`}>
                            Contact Us
                        </Link>
                    </li>
                </ul>
            </div>
        </nav>
    )
}

export default Navbar